import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import invariant from 'react-utils/invariant';
import isNumber from 'transmute/isNumber';
import { jsx as _jsx } from "react/jsx-runtime";
const getDateForValueInUserTz = (value, type) => {
  const dateArrayForValue = I18n.moment[type](value).toArray() // makes an array of format [YEAR, MONTH, DAY, HOUR, MIN, SEC, MILSEC]
  .slice(0, 3); // get just the YEAR, MONTH, DAY of the value

  //@ts-expect-error Passing just a number[] is supported.
  return I18n.moment.userTz(dateArrayForValue); // get the timestamp for 00:00:00 at that date in the user's timezone
};
export const getDaysFromToday = (value, type) => {
  const startOfTodayUserTz = I18n.moment.userTz().startOf('day'); // moment object for today at 00:00:00 at that date in the user's tz
  const startOfDayForValueUserTz = getDateForValueInUserTz(value, type); // moment object for 00:00:00 of the start of the DATE supplied in value
  const diff = startOfDayForValueUserTz.diff(startOfTodayUserTz, 'days'); // get value - today for user tz
  return diff;
};
export const getRecentRelativeString = (value, type) => {
  const days = {
    '-1': 'yesterday',
    0: 'today',
    1: 'tomorrow'
  };
  const dayDiff = getDaysFromToday(value, type);
  if (dayDiff > 1 || dayDiff < -1 || !isNumber(dayDiff)) {
    return false;
  }
  return I18n.text(`tasks-table.cells.dateTimeCell.${days[dayDiff]}`);
};
export const getDateLabel = (value, showTime = true, type) => {
  invariant(type, 'type is required');
  const recentDate = getRecentRelativeString(value, type);
  if (recentDate && showTime) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.dateTimeCell.relativeTime",
      options: {
        day: recentDate,
        time: I18n.moment.userTz(value).format('LT')
      }
    });
  } else if (recentDate) {
    return recentDate;
  }
  return null;
};